"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsService = exports.UNIT_OPTIONS = exports.DEFAULT_UNIT = exports.DEFAULT_DATE = exports.DATE_OPTIONS = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const i18n_1 = require("../i18n");
const index_1 = require("./index");
const user_service_1 = require("./user.service");
exports.DATE_OPTIONS = [
    'MM/DD/YYYY',
    'DD/MM/YYYY'
];
exports.DEFAULT_DATE = exports.DATE_OPTIONS[0];
exports.DEFAULT_UNIT = core_shared_1.IkeUnit.FEET;
exports.UNIT_OPTIONS = [
    { unit: core_api_1.IkeUnitDistance.METER, label: i18n_1.T.UNIT_METER },
    { unit: core_api_1.IkeUnitDistance.FEET, label: i18n_1.T.UNIT_FEET_INCH }
];
class UserSettingsService {
    constructor() {
        this.__priority = 100;
    }
    getSettings() {
        var currentUser = index_1.Services.User.current;
        if (currentUser == null) {
            throw new Error('Invalid user.');
        }
        if (currentUser.settings == null) {
            currentUser.settings = {};
        }
        return currentUser.settings;
    }
    setDateFormat(dateFormat) {
        dateFormat = dateFormat.toUpperCase();
        if (exports.DATE_OPTIONS.indexOf(dateFormat) === -1) {
            throw new Error('Invalid DateFormat.');
        }
        if (dateFormat === this.dateFormat) {
            return Promise.resolve(index_1.Services.User.current);
        }
        return user_service_1.UserMutator.setDateFormat(dateFormat);
    }
    setUnits(units) {
        const ikeUnits = core_shared_1.IkeUnit.toUnitDistance(units);
        if (ikeUnits == null) {
            throw new Error('Invalid Unit: ' + units);
        }
        if (ikeUnits === this.units) {
            return Promise.resolve(index_1.Services.User.current);
        }
        return user_service_1.UserMutator.setUnits(ikeUnits);
    }
    setDepartment(departmentId) {
        if (departmentId == null) {
            throw new Error('Invalid departmentId');
        }
        if (departmentId === this.departmentId) {
            return Promise.resolve(index_1.Services.User.current);
        }
        index_1.Services.Route.departmentReset();
        return user_service_1.UserMutator.setDepartment(departmentId);
    }
    get units() {
        if (index_1.Services.User.current == null) {
            return exports.DEFAULT_UNIT;
        }
        const settings = this.getSettings();
        if (settings.units == null) {
            return exports.DEFAULT_UNIT;
        }
        return settings.units || exports.DEFAULT_UNIT;
    }
    get dateFormat() {
        if (index_1.Services.User.current == null) {
            return exports.DEFAULT_DATE;
        }
        const settings = this.getSettings();
        if (settings.date == null) {
            return exports.DEFAULT_DATE;
        }
        return settings.date || exports.DEFAULT_DATE;
    }
    get departmentId() {
        if (index_1.Services.User.current == null) {
            return null;
        }
        const settings = this.getSettings();
        if (settings.departmentId != null) {
            return settings.departmentId;
        }
        return null;
    }
}
exports.UserSettingsService = UserSettingsService;
tslib_1.__decorate([
    mobx_1.computed
], UserSettingsService.prototype, "units", null);
tslib_1.__decorate([
    mobx_1.computed
], UserSettingsService.prototype, "dateFormat", null);
tslib_1.__decorate([
    mobx_1.computed
], UserSettingsService.prototype, "departmentId", null);
//# sourceMappingURL=user.settings.service.js.map